import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';

import {Metric, MetricsFilter} from '../../models/Metric';
import {updateMetricsFilter} from '../../actions/metrics';
import {bindActionCreators} from 'redux';
import {SingleSelector} from '../general/SingleSelector';
import {Checkbox} from '../general/Checkbox';

interface StateProps {
  metricsFilter: MetricsFilter
}

interface DispatchProps {
  updateMetricsFilter: (metricsFilter: MetricsFilter) => void
}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps

const controlSelectStyle = (base: any, state: any) => {
  return {'border': 'none', '&:hover': {
      cursor: 'pointer',
      border: 'none',
      backgroundColor: 'rgba(192,241,148,0.78)',
    }};
};

const MetricsControlPanel = ({metricsFilter, updateMetricsFilter}: Props) => {
  const [localMetricsFilter, setMetricsFilter] = useState(metricsFilter);

  useEffect(() => {
    setMetricsFilter(metricsFilter);
  }, [metricsFilter]);

  const changeMetricsFilter = (paramName: string, value: any) => {
    const newMetricsFilter: MetricsFilter = {...localMetricsFilter, ...{[paramName]: value}}
    setMetricsFilter(newMetricsFilter)
    updateMetricsFilter(newMetricsFilter)
  }

  const valuesDays = [{value: 7, label: '7 days'}, {value: 14, label: '14 days'}, {value: 30, label: '30 days'}, {value: 30000, label: 'All Time'}]
  const selectedLabel = valuesDays.find(e => e.value === metricsFilter.createdFromDays)?.label;
  return (
    <div className={'metrics-panel'}>
      <Checkbox
        key={'visibility-checkbox'}
        style={{marginLeft: '10px'}}
        switch={(isActive) => {changeMetricsFilter('showIsFree', isActive)}}
        isActive={localMetricsFilter.showIsFree}
        text={'Show is Free'}
      />
      <SingleSelector
        change={(period) => {
          if (!isNaN(period) && Number(period) > 0) {
            changeMetricsFilter( 'createdFromDays', Number(period));
          }
        }}
        isClearable={true}
        selectedValue={metricsFilter.createdFromDays}
        selectedLabel={selectedLabel}
        control={controlSelectStyle}
        style={{
          alignItems: 'center',
          marginLeft: '30px',
          width: '160px',
        }}
        options={valuesDays}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  metricsFilter: state.metrics.metricsFilter
});

const mapDispatchToProps = (dispatch: any) => ({
  updateMetricsFilter: bindActionCreators(updateMetricsFilter, dispatch),
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(MetricsControlPanel);
